module.exports = __webpack_public_path__ + "static/media/8-considerations-for-api-design.8cb4d673.jpg";